import {
  createStore,
} from 'vuex';

import mainModule from './mainModule';

const store = createStore(mainModule);
export default store;
